import { DepartmentAccessLevelDTO, UserTypeDTO } from '@/api/trafikportalen';

export type GrantedAccessLevel = Exclude<DepartmentAccessLevelDTO, 'none'>;

export const userTypeByAccessLevel: Record<GrantedAccessLevel, UserTypeDTO> = {
  viewer: UserTypeDTO.viewer,
  'bearer-manager': UserTypeDTO['bearer-manager'],
  editor: UserTypeDTO.admin,
};

const accessLevelRank: Record<DepartmentAccessLevelDTO, number> = {
  none: 0,
  viewer: 1,
  'bearer-manager': 2,
  editor: 3,
};

export const coversAccessLevel = (
  level: DepartmentAccessLevelDTO,
  other: DepartmentAccessLevelDTO,
) => accessLevelRank[level] >= accessLevelRank[other];
